import RoutesRatelier from './ratelier/routes';
import RoutesArmes from './armes/routes';
import RoutesMesDemarches from './mes-demarches/routes';
import RoutesMesTitresDeDetention from './mes-titres-de-detention/routes';
import RoutesMonCompte from './mon-compte/routes';
import RoutesNotifications from './notifications/routes';
import RoutesMentionsLegales from './mentions-legales/routes';
import RoutesDonneesPersonnelles from './donnees-personnelles/routes';
import RoutesGuideUtilisateurSIA from './aide/routes';
import RoutesAccessibilite from './accessibilite/routes';
import { initSubRoutes } from '../../utils/router';

const RoutesEspaceDetenteurs = initSubRoutes({
    route: '/espace-detenteurs',
    subroutes: {
        ratelier: RoutesRatelier,
        armes: RoutesArmes,
        demarches: RoutesMesDemarches,
        mesTitresDeDetention: RoutesMesTitresDeDetention,
        monCompte: RoutesMonCompte,
        notification: RoutesNotifications,
        mentionsLegales: RoutesMentionsLegales,
        donneesPersonnelles: RoutesDonneesPersonnelles,
        guideUtilisateurSIA: RoutesGuideUtilisateurSIA,
        accessibilite: RoutesAccessibilite,
    },
    nom: 'Espace Détenteurs',
});

export default RoutesEspaceDetenteurs;
